import { showMessage } from "../customhooks/useNotifier";
import environment from "../environments/environment";
const API_URL = environment.REACT_APP_BACKEND_API_BASE_URL;

const authService = {
  login: async (data) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/auth/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        credentials: "include",
      });

      if (!response.ok) {
        const errorData = await response.json();

        let errorMessage = "Invalid credentials";
        if (
          typeof errorData.message === "object" &&
          errorData.message !== null
        ) {
          errorMessage = errorData.message.message || errorMessage;
        } else if (typeof errorData.message === "string") {
          errorMessage = errorData.message;
        }

        console.log("login error message --->", errorMessage);
        throw new Error(errorMessage);
      }

      const responseData = await response.json();
      console.log("login --->", responseData);

      showMessage("Login successful", "success");
      localStorage.setItem("access_token", responseData.access_token);
      localStorage.setItem("user", JSON.stringify(responseData.user));
      // localStorage.setItem('websiteData', JSON.stringify(responseData.websiteData));
      return responseData;
    } catch (error) {
      console.log("catch login error---->", error);
      showMessage(error.message || "Login failed", "error");
      throw new Error(error.message || "Login failed");
    }
  },
  register: async (data) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });

      const responseData = await response.json();

      if (!response.ok) {
        let errorMessage = "Registration failed";

        // If `message` is an object (like in your example)
        if (
          typeof responseData.message === "object" &&
          responseData.message !== null
        ) {
          errorMessage = responseData.message.message || errorMessage;
        } else if (typeof responseData.message === "string") {
          errorMessage = responseData.message;
        }

        throw new Error(errorMessage);
      }

      showMessage("Register successful", "success");
      console.log("Registration --->", responseData);
      return responseData;
    } catch (error) {
      console.log("catch Registration error ---->", error);
      showMessage(error.message || "Registration failed", "error");
      throw error;
    }
  },
  refreshToken: async () => {
    try {
      const response = await fetch(`${API_URL}/api/v1/auth/refresh`, {
        method: "POST",
        credentials: "include",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Refresh token failed");
      }

      const responseData = await response.json();
      console.log("Refresh Token --->", responseData);

      // Store new access token
      localStorage.setItem("access_token", responseData.access_token);
      return responseData;
    } catch (error) {
      console.log("catch Failed to refresh token error---->", error);
      // throw new Error(error.message || 'Failed to refresh token');
    }
  },
  logout: async () => {
    try {
      // Optionally, make an API call to log out the user server-side
      await fetch(`${API_URL}/api/v1/auth/logout`, {
        method: "POST",
        credentials: "include", // Send cookies along with the request
      });

      // Remove tokens and user data from local storage
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      // localStorage.removeItem('websiteData');
      localStorage.removeItem("userSession");

      localStorage.clear();

      // Optionally, clear the cookies as well, if needed
      // document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;'

      // Notify the user about the logout
      // showMessage('Logged out successfully', 'success');
      sessionStorage.setItem("logoutMessage", "Logged out successfully");

      // Redirect the user to the login page
      window.location.href = "/signin";
    } catch (error) {
      showMessage(error.message || "Logout failed", "error");
    }
  },
};
export default authService;
